import Animation from './Animation';
import { play } from '../../../SoundManager';

export default class Gold extends Animation {

	constructor (master) {

		super(master, 0);
		this.loadAudio("gold");
	}

	run () {

	}
}